export const aboutUsHeaderBgImage = require('assets/images/about-us/aboutUsHeaderBg.png');
export const leftGridAboutImage = require('assets/images/about-us/leftGridAboutImage.jpg');
export const rightTopGridAboutImage = require('assets/images/about-us/rightTopGridAboutImage.jpg');
export const rightBottomGridAboutImage = require('assets/images/about-us/rightBottomGridAboutImage.jpg');
export const completeCustomizationImage = require('assets/images/about-us/completeCustomizationImage.jpg');
export const easeOfUseImage = require('assets/images/about-us/easeOfUseImage.jpg');
export const intuitiveNavigationImage = require('assets/images/about-us/intuitiveNavigationImage.jpg');
export const ourMissionImage = require('assets/images/about-us/ourMissionImage.jpg');
export const ourVisionImage = require('assets/images/about-us/ourVisionImage.jpg');
export const unlimitedPossibilitiesImage = require('assets/images/about-us/unlimitedPossibilitiesImage.jpg');
export const whyEnergyImage = require('assets/images/about-us/whyEnergyImage.jpg');
export const batteryImage = require('assets/images/about-us/battery.webp');
export const evChargingImage = require('assets/images/about-us/evCharging.webp');
export const rebatesImage = require('assets/images/about-us/rebates.webp');
export const retailImage = require('assets/images/about-us/retail.webp');
